module.exports = __webpack_public_path__ + "static/models/sn_road_00.c96dbac.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/sn_road_00.json
// module id = 523
// module chunks = 1